import axios from 'axios';
import URLManager from '../../funcionalidadeNavbar/URLManager';



// Configuração do axios para incluir o token JWT
axios.interceptors.request.use(config => {
  const token = sessionStorage.getItem("usuarioToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const _url = URLManager.getBaseURL();

export const CronometroService = {
  async iniciar(processoId) {
    try {
      const response = await axios.post(`${_url}/cronometro/iniciar/${processoId}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao iniciar cronômetro:", error);
      throw error;
    }
  },

  async parar(processoId) {
    try {
      const response = await axios.post(`${_url}/cronometro/parar/${processoId}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao parar cronômetro:", error);
      throw error;
    }
  },

  async getTempo(processoId) {
    try {
      const response = await axios.get(`${_url}/cronometro/tempo/${processoId}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao obter tempo:", error);
      throw error;
    }
  }
};